export default "__VITE_ASSET__8BvRr42F__"